/* Pip & Wells — geursectie: prijs per aantal in de popup, gouden glans op de knoppen
   en een gouden lichtstraal naar het winkelmandje zodra een geur echt is toegevoegd. */
(() => {
  if (window.pwFragranceMotion) return;
  window.pwFragranceMotion = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Stijl: heldere gouden glans (themakleuren #B8943F / #e7c36a / ivoor) ---------- */
  const css = `
  @keyframes pw-fm-sweep{from{transform:translateX(-140%) skewX(-22deg)}to{transform:translateX(360%) skewX(-22deg)}}
  @keyframes pw-fm-press{0%{box-shadow:0 0 0 0 rgba(231,195,106,.55)}100%{box-shadow:0 0 0 14px rgba(231,195,106,0)}}
  @keyframes pw-fm-cart{0%{transform:scale(1)}30%{transform:scale(1.28) rotate(-6deg)}55%{transform:scale(.94) rotate(3deg)}100%{transform:scale(1)}}
  @keyframes pw-fm-ring{0%{opacity:.95;transform:translate(-50%,-50%) scale(.3)}100%{opacity:0;transform:translate(-50%,-50%) scale(2.6)}}
  @keyframes pw-fm-spark{0%{opacity:1;transform:translate(-50%,-50%) translate(0,0) scale(1)}100%{opacity:0;transform:translate(-50%,-50%) translate(var(--dx),var(--dy)) scale(.2)}}
  .pw-fragrances__add{position:relative;overflow:hidden;isolation:isolate;-webkit-tap-highlight-color:transparent;
    transition:background-color .25s ease,border-color .25s ease,color .25s ease,box-shadow .25s ease,filter .25s ease}
  .pw-fragrances__add::after{content:"";position:absolute;inset:0 auto 0 0;width:42%;z-index:-1;pointer-events:none;
    background:linear-gradient(100deg,rgba(255,240,200,0) 0%,rgba(240,208,120,.28) 28%,rgba(255,244,214,.85) 50%,rgba(240,208,120,.28) 72%,rgba(255,240,200,0) 100%);
    transform:translateX(-140%) skewX(-22deg)}
  .pw-detail__add::after{background:linear-gradient(100deg,rgba(255,255,255,0) 0%,rgba(255,248,226,.22) 30%,rgba(255,250,236,.75) 50%,rgba(255,248,226,.22) 70%,rgba(255,255,255,0) 100%)}
  @media (hover:hover){
    .pw-fragrances__add:not(.pw-detail__add):hover:not(:disabled){background-color:#f4e3b5;border-color:#b8943f;color:#3a2d10;box-shadow:0 8px 22px rgba(184,148,63,.28)}
    .pw-detail__add:hover:not(:disabled){filter:brightness(1.1) saturate(1.06);box-shadow:0 12px 28px rgba(212,170,80,.38)}
    .pw-fragrances__add:hover:not(:disabled)::after{animation:pw-fm-sweep .95s cubic-bezier(.25,.6,.3,1) forwards}
  }
  .pw-fragrances__add:focus-visible:not(:disabled)::after{animation:pw-fm-sweep .95s cubic-bezier(.25,.6,.3,1) forwards}
  .pw-fragrances__add.pw-fm-pressed::after{animation:pw-fm-sweep .55s ease-out forwards}
  .pw-fragrances__add.pw-fm-pressed{animation:pw-fm-press .6s ease-out}
  .pw-fragrances__add:disabled::after{display:none}
  /* Tijdens het toevoegen (aria-busy) niet vervagen maar goud blijven glanzen. */
  .pw-fragrances__add[aria-busy="true"]{opacity:1!important;cursor:progress}
  .pw-fragrances__add:not(.pw-detail__add)[aria-busy="true"]{background-color:#f4e3b5!important;border-color:#b8943f!important;color:#3a2d10!important;box-shadow:0 8px 22px rgba(184,148,63,.28)}
  .pw-detail__add[aria-busy="true"]{background:rgb(221,193,141)!important;border-color:rgb(183,152,84)!important;color:rgb(48,44,39)!important;filter:brightness(1.1) saturate(1.06);box-shadow:0 12px 28px rgba(212,170,80,.38)}
  .pw-fragrances__add[aria-busy="true"]::after{display:block!important;animation:pw-fm-sweep .9s cubic-bezier(.4,0,.2,1) infinite!important}
  .pw-fm-cart-bump{animation:pw-fm-cart .6s cubic-bezier(.3,1.4,.5,1)}
  .pw-fm-layer{position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden}
  .pw-fm-layer[popover]{width:100vw;height:100vh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:transparent;color:inherit}
  @keyframes pw-fm-ghost-in{from{opacity:0;transform:scale(.6)}to{opacity:1;transform:scale(1)}}
  .pw-fm-ghost{position:absolute;width:44px;height:44px;margin:-22px 0 0 -22px;border-radius:50%;background:#fbf9f4;color:#0a0a0a;
    display:grid;place-items:center;box-shadow:0 6px 18px rgba(24,20,13,.18),0 0 0 1px rgba(184,148,63,.35);animation:pw-fm-ghost-in .25s ease-out both}
  .pw-fm-ghost svg{width:22px;height:22px}
  .pw-fm-orb{position:absolute;left:0;top:0;width:20px;height:20px;margin:-10px 0 0 -10px;border-radius:50%;
    background:radial-gradient(circle,#fffaf0 0%,#ffe9a8 30%,#e7c36a 58%,rgba(184,148,63,0) 72%);
    box-shadow:0 0 18px 6px rgba(255,214,120,.65),0 0 40px 12px rgba(212,170,80,.35);will-change:transform}
  .pw-fm-trail{position:absolute;left:0;top:0;border-radius:50%;pointer-events:none;
    background:radial-gradient(circle,#fff6dc 0%,#f0cf7a 45%,rgba(184,148,63,0) 72%);filter:blur(.6px);will-change:transform,opacity}
  .pw-fm-ring{position:absolute;width:30px;height:30px;border-radius:50%;border:2px solid #e7c36a;
    box-shadow:0 0 14px rgba(255,214,120,.7);animation:pw-fm-ring .7s ease-out forwards}
  .pw-fm-spark{position:absolute;width:5px;height:5px;border-radius:50%;background:#ffe39a;
    box-shadow:0 0 6px 2px rgba(255,214,120,.8);animation:pw-fm-spark .7s ease-out forwards}
  @media (prefers-reduced-motion:reduce){
    .pw-fragrances__add::after{width:100%;transform:none;opacity:0;transition:opacity .35s ease;animation:none!important;
      background:linear-gradient(100deg,rgba(255,240,200,0) 5%,rgba(255,236,190,.7) 50%,rgba(255,240,200,0) 95%)}
    .pw-fragrances__add:hover:not(:disabled)::after,.pw-fragrances__add:focus-visible:not(:disabled)::after,.pw-fragrances__add.pw-fm-pressed::after{opacity:.75}
    .pw-fm-cart-bump{animation-duration:.35s}
    .pw-fragrances__add[aria-busy="true"]::after{animation:none!important;opacity:.75}
  }`;
  const style = document.createElement('style');
  style.id = 'pw-fragrance-motion';
  style.textContent = css;
  document.head.append(style);

  /* ---------- Gouden straal naar het winkelmandje ---------- */
  let flight = null; // lopende straal: start direct bij de klik, het oplichten van het mandje wacht op bevestiging
  const press = button => {
    button.classList.remove('pw-fm-pressed');
    void button.offsetWidth;
    button.classList.add('pw-fm-pressed');
    setTimeout(() => button.classList.remove('pw-fm-pressed'), 650);
  };
  window.addEventListener('click', e => { const b = e.target.closest?.('.pw-fragrances__add'); if (b && !b.disabled) press(b); }, true);
  // submit vuurt direct bij de klik (window-capture loopt vóór pw-fragrance-shopping.js); ongeldige formulieren sturen geen submit.
  window.addEventListener('submit', e => {
    const b = e.submitter;
    if (!b?.matches?.('.pw-fragrances__add') || b.disabled || b.getAttribute('aria-busy') === 'true') return;
    if (flight && !flight.done) return; // geen dubbele straal bij dubbelklikken
    launch(b.getBoundingClientRect());
  }, true);
  document.addEventListener('variant:add', () => { if (flight && !flight.done) flight.confirm(); });

  // Header op de telefoon direct in beeld halen (thema verbergt hem bij naar beneden scrollen) en
  // tijdens de straal niet laten wegschuiven. Geeft een functie terug die dat weer vrijgeeft.
  const holdHeader = () => {
    const h = document.querySelector('store-header');
    if (!h || typeof h.show !== 'function') return () => {};
    if (h._isVisible === false) h.show();
    h.hide = async () => {};
    return () => { delete h.hide; };
  };

  const cartTarget = () => {
    const icons = [...document.querySelectorAll('a[aria-controls="cart-drawer"], a[href$="/cart"]')].filter(el => el.getBoundingClientRect().width > 0);
    const icon = icons.find(el => el.closest('store-header')) || icons[0];
    if (!icon) return null;
    const r = icon.getBoundingClientRect();
    // Eindpositie gebruiken: tel een lopende in/uitschuif-animatie van de header niet mee.
    let shift = 0;
    const h = icon.closest('store-header');
    if (h) { try { shift = new DOMMatrixReadOnly(getComputedStyle(h).transform).m42 || 0; } catch (_) {} }
    return { el: icon, x: r.left + r.width / 2, y: Math.max(14, r.top - shift + r.height / 2) };
  };

  const arrive = (layer, target, calm = false, ghost = null) => {
    const ring = document.createElement('span');
    ring.className = 'pw-fm-ring';
    ring.style.left = `${target.x}px`; ring.style.top = `${target.y}px`;
    layer.append(ring);
    for (let i = 0; i < (calm ? 0 : 10); i++) {
      const s = document.createElement('span');
      const a = (Math.PI * 2 * i) / 10 + Math.random() * 0.4;
      const d = 18 + Math.random() * 16;
      s.className = 'pw-fm-spark';
      s.style.left = `${target.x}px`; s.style.top = `${target.y}px`;
      s.style.setProperty('--dx', `${Math.cos(a) * d}px`);
      s.style.setProperty('--dy', `${Math.sin(a) * d}px`);
      layer.append(s);
    }
    if (ghost) { ghost.classList.remove('pw-fm-cart-bump'); void ghost.offsetWidth; ghost.classList.add('pw-fm-cart-bump'); }
    const bump = target.el.querySelector('svg') || target.el;
    bump.classList.remove('pw-fm-cart-bump'); void bump.offsetWidth; bump.classList.add('pw-fm-cart-bump');
    setTimeout(() => bump.classList.remove('pw-fm-cart-bump'), 700);
    const count = document.querySelector('cart-count');
    if (count) { count.classList.remove('pw-fm-cart-bump'); void count.offsetWidth; count.classList.add('pw-fm-cart-bump'); setTimeout(() => count.classList.remove('pw-fm-cart-bump'), 700); }
  };

  const launch = rect => {
    const release = holdHeader();
    const target = cartTarget();
    if (!target) { release(); return; }
    const start = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    const layer = document.createElement('div');
    layer.className = 'pw-fm-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.append(layer);
    // Als popover komt de laag ook boven een geopende popup (dialog in de top layer).
    if (layer.showPopover) { try { layer.setAttribute('popover', 'manual'); layer.showPopover(); } catch (_) {} }
    const calm = reduce.matches; // rustige variant: rechte, korte straal zonder vonkjes
    // Bedekt een geopende popup de header (telefoon), toon dan het mandje op dezelfde plek in de laag.
    let ghost = null;
    if (document.querySelector('dialog[open]')) {
      ghost = document.createElement('span');
      ghost.className = 'pw-fm-ghost';
      ghost.style.left = `${target.x}px`; ghost.style.top = `${target.y}px`;
      const svg = target.el.querySelector('svg');
      if (svg) ghost.append(svg.cloneNode(true));
      layer.append(ghost);
    }
    const orb = document.createElement('span');
    orb.className = 'pw-fm-orb';
    layer.append(orb);
    // Sierlijke boog: eerst omhoog, dan glijdend het winkelmandje in; blijft altijd binnen beeld.
    const dist = Math.hypot(target.x - start.x, target.y - start.y);
    const ctrl = calm ? { x: (start.x + target.x) / 2, y: (start.y + target.y) / 2 } : { x: start.x + (target.x - start.x) * 0.18, y: Math.max(12, target.y - 46) };
    const duration = calm ? 480 : Math.min(1050, Math.max(650, dist * 0.9));
    const ease = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const at = t => ({
      x: (1 - t) * (1 - t) * start.x + 2 * (1 - t) * t * ctrl.x + t * t * target.x,
      y: (1 - t) * (1 - t) * start.y + 2 * (1 - t) * t * ctrl.y + t * t * target.y
    });
    // Pad vooraf berekenen en via de Web Animations API afspelen: soepel, en ruimt zichzelf altijd op.
    const N = 28;
    const frames = [];
    for (let k = 0; k <= N; k++) {
      const raw = k / N;
      const p = at(ease(raw));
      frames.push({ transform: `translate(${p.x}px,${p.y}px) scale(${1.25 - raw * 0.55})`, offset: raw });
    }
    if (orb.animate) {
      orb.animate(frames, { duration, easing: 'linear', fill: 'forwards' });
      // Komeetstaart: kleinere, vervagende lichtjes die de bol volgen.
      const tail = calm ? 10 : 42;
      for (let k = 1; k <= tail; k++) {
        const tr = document.createElement('span');
        const size = Math.max(3, 14 - k * 0.26);
        tr.className = 'pw-fm-trail';
        tr.style.width = tr.style.height = `${size}px`;
        tr.style.marginLeft = tr.style.marginTop = `${-size / 2}px`;
        tr.style.opacity = '0';
        layer.append(tr);
        const fade = 0.9 - k * (0.78 / tail);
        tr.animate(frames.map(f => ({ ...f, opacity: f.offset < 0.04 ? 0 : f.offset > 0.94 ? 0 : fade })), { duration, delay: k * (calm ? 16 : 6), easing: 'linear', fill: 'both' });
      }
    } else {
      orb.style.transform = frames[N].transform;
    }
    const state = flight = { done: false, landed: false, confirmed: false };
    let hold = null;
    const finish = ok => {
      if (state.done) return;
      state.done = true;
      clearTimeout(state.timer);
      hold?.cancel();
      if (ok) { orb.remove(); arrive(layer, target, calm, ghost); }
      else orb.animate?.([{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' });
      if (ghost) setTimeout(() => ghost.animate?.([{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' }), 750);
      setTimeout(() => { layer.remove(); release(); }, 1300);
    };
    state.confirm = () => { state.confirmed = true; if (state.landed) finish(true); };
    // Komt er geen bevestiging (bv. fout of uitverkocht), dan dooft de bol rustig uit zonder mandje-effect.
    state.timer = setTimeout(() => finish(false), 8000);
    setTimeout(() => {
      state.landed = true;
      if (state.confirmed) return finish(true);
      // Nog geen bevestiging: bol blijft zacht pulserend bij het mandje wachten.
      if (orb.animate && !state.done) hold = orb.animate([{ transform: frames[N].transform }, { transform: frames[N].transform.replace(/scale\([^)]*\)/, 'scale(0.95)') }, { transform: frames[N].transform }], { duration: 520, iterations: Infinity, easing: 'ease-in-out' });
    }, duration);
  };

  /* ---------- Prijs in de popup volgt het aantal + staffelkorting ---------- */
  const money = (cents, sample) => {
    const m = /(\d[\d.,'’\s  ]*\d)/.exec(sample || '');
    const v = cents / 100;
    if (!m) return v.toFixed(2).replace('.', ',');
    const num = m[1];
    const dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : '';
    const thou = /\d/.test(num.charAt(1)) ? '' : num.charAt(1);
    const [i, f] = v.toFixed(dec ? 2 : 0).split('.');
    const out = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (dec ? dec + f : '');
    return sample.slice(0, m.index) + out + sample.slice(m.index + num.length);
  };
  let cartItems = null;
  const update = dialog => {
    const form = dialog?.querySelector('[data-pw-detail-form]');
    const box = form?.querySelector('[data-pw-detail-price]');
    if (!box) return;
    const unit = Number(box.dataset.unit) || 0;
    const tierQty = Number(box.dataset.tierQty) || 0;
    const percent = Number(box.dataset.tierPercent) || 0;
    const qty = Math.max(1, parseInt(form.elements.namedItem('quantity')?.value, 10) || 1);
    const total = unit * qty;
    const ids = (form.dataset.pwDiscountProductIds || '').split('|');
    const inCart = cartItems
      ? cartItems.filter(item => !item.selling_plan_allocation && ids.includes(String(item.product_id))).reduce((sum, item) => sum + item.quantity, 0)
      : Number(form.dataset.pwCartGroupQuantity) || 0;
    const applied = tierQty > 0 && percent > 0 && qty + inCart >= tierQty;
    const final = applied ? (unit - Math.floor(unit * percent / 100)) * qty : total;
    box.querySelector('[data-pw-price-current]').textContent = money(final, box.dataset.sample);
    const compare = box.querySelector('[data-pw-price-compare]');
    compare.hidden = !applied;
    compare.textContent = applied ? money(total, box.dataset.sample) : '';
    const hint = dialog.querySelector('[data-pw-detail-tier]');
    if (hint) {
      hint.textContent = applied ? hint.dataset.applied.replace('[amount]', money(total - final, box.dataset.sample)) : hint.dataset.before;
      hint.classList.toggle('is-applied', applied);
    }
  };
  const fromEvent = event => event.target instanceof Element && event.target.closest('dialog.pw-fragrance-detail');
  document.documentElement.addEventListener('cart:change', event => {
    if (!Array.isArray(event.detail?.cart?.items)) return;
    cartItems = event.detail.cart.items;
    document.querySelectorAll('dialog.pw-fragrance-detail').forEach(update);
  });
  ['input', 'change', 'focusin'].forEach(type => document.addEventListener(type, event => {
    const dialog = fromEvent(event);
    if (dialog) update(dialog);
  }, true));
  document.addEventListener('click', event => {
    const dialog = fromEvent(event);
    if (dialog && event.target.closest('.quantity-selector__button')) setTimeout(() => update(dialog), 0);
  }, true);
})();
